import React, { useState } from 'react';
import './Projects.css';
import CustomModal from '../components/CustomModal';
import ProjectDescriptionSlide from '../components/ProjectDescriptionSlide';
import { projects as defaultProjects } from '../data/projectsData';
import Button from '../components/Button';

interface ProjectsProps {
  projects?: typeof defaultProjects;
}

const Projects: React.FC<ProjectsProps> = ({ projects = defaultProjects }) => {
  const [show, setShow] = useState(false);
  const [selectedProject, setSelectedProject] = useState<typeof defaultProjects[number] | null>(null);
  const [slideOpen, setSlideOpen] = useState(false);

  const handleClose = () => {
    setShow(false);
    setSelectedProject(null);
  };

  const handleShow = (project: typeof defaultProjects[number]) => {
    setSelectedProject(project);
    setShow(true);
  };

  const handleCardClick = (project: typeof defaultProjects[number]) => {
    setSelectedProject(project);
    setSlideOpen(true);
  };

  const handleSlideClose = () => {
    setSlideOpen(false);
  };
  return (
    <section className="projects" id="projects">
      <div className="projects__header">
        <div>
          <p className="projects__eyebrow">PORTFOLIO</p>
          <h2 className="projects__heading">Technical Routes.</h2>
        </div>
        <p className="projects__quote">"The line is the logic of the mountain."</p>
      </div>
      <div className="projects__grid">
        {projects.map((p) => (
          <div className="project-card" key={p.title} onClick={() => handleCardClick(p)}>
            <div className="project-card__meta">
              <span className="project-card__category">{p.category}</span>
              <span className="project-card__grade">{p.grade}</span>
            </div>
            <h3 className="project-card__title">{p.title}</h3>
            <p className="project-card__desc">{p.description}</p>
            <div className="project-card__visual">
              <img src={p.image} alt={`${p.title} screenshot`} className="project-card__image" />
            </div>

          </div>
        ))}
      </div>
      <CustomModal show={show} setShow={setShow} onHide={handleClose} project={selectedProject} />
      <ProjectDescriptionSlide 
        project={selectedProject} 
        isOpen={slideOpen} 
        onClose={handleSlideClose} 
      />

    </section>
  );
};

export default Projects;
